import { FocusEditor } from "@/components/focus/focus-editor";

export default function FocusPage() {
  return <FocusEditor />;
}
